import React from 'react';
import { Award, CheckCircle2, ShieldCheck, FileText } from 'lucide-react';
import { seoCmsEngine } from '../../services/seoCmsEngine';

export const MethodologyHub: React.FC = () => {
  const docs = seoCmsEngine.getMethodologyDocs();

  return (
    <div className="space-y-8 pb-12">
      {/* Banner */}
      <div className="bg-slate-900 text-white rounded-2xl p-8 shadow-xl space-y-4">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-300 text-xs font-semibold border border-emerald-500/30">
          <Award className="w-3.5 h-3.5" />
          YamooPay Methodology Center
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight">Calculation & Financial Data Methodology</h1>
        <p className="text-slate-300 text-sm max-w-2xl leading-relaxed">
          Complete mathematical transparency regarding exchange rate aggregation, statutory tax bracket formulas, and mortgage compounding algorithms.
        </p>
      </div>

      {/* Methodology Cards */}
      <div className="space-y-6">
        {docs.map((doc) => (
          <div key={doc.id} className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 space-y-4">
            <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 pb-3">
              <div>
                <span className="px-2.5 py-0.5 rounded bg-emerald-100 text-emerald-800 text-xs font-bold uppercase">
                  {doc.category}
                </span>
                <h2 className="text-xl font-bold text-slate-900 mt-1">{doc.title}</h2>
              </div>
              <span className="text-xs text-slate-400 font-medium">Last Verified: {doc.lastUpdated}</span>
            </div>

            <p className="text-slate-600 text-sm leading-relaxed">{doc.summary}</p>

            <div className="bg-slate-50 p-4 rounded-xl border border-slate-200/80 space-y-2">
              <div className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
                <ShieldCheck className="w-4 h-4 text-emerald-600" />
                Key Mathematical Standards
              </div>
              <ul className="space-y-1.5 text-xs text-slate-700">
                {doc.keyPoints.map((pt, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0 mt-0.5" />
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
